var $$ = $$ || {};

$$.ScrollList = class ScrollList {
	constructor (root, options = {}) {
		var defaultOptions = {
			headerHeight: 60
		};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.containersItemPaddingTop = 0;
		this.linksPaddingTop = 0;

		this.controller = null;

		this._cacheNodes();
		this._cacheReady();
		this._initScrollMagic();
	}

	_cacheNodes () {
		this.nodes = {
			linksContainer: this.root.find('.js-links'),
			containersContainer: this.root.find('.js-containers'),
			containersHeader: this.root.find('.js-container-header'),

			scrollToButton: this.root.find('.js-scrollto')
		};

		this.nodes.links = this.nodes.linksContainer.find('.item');
		this.nodes.containers = this.nodes.containersContainer.find('div.item');
	}

	_cacheReady () {
		var newPaddingTop = parseInt(this.nodes.containersHeader.css('padding-top'), 10);

		if ( newPaddingTop === 0 || !newPaddingTop ) {
			this.containersItemPaddingTop = 29;// todo 29 margin h3
			newPaddingTop = this.containersItemPaddingTop + 1;
		} else {
			newPaddingTop = newPaddingTop + 3;
		}

		this.linksPaddingTop = newPaddingTop + parseInt(this.nodes.containersContainer.parent().css('padding-top'), 10);

		this.nodes.scrollToButton.on('click', (event) => {
			event.preventDefault();

			if (this.controller) {
				var target = $(event.currentTarget.getAttribute("href"));

				this.controller.scrollTo(target.get(0));
			}
		});
	}

	_initScrollMagic () {
		this.controller = new ScrollMagic.Controller();

		new ScrollMagic.Scene({
			duration: () => {
				return this.nodes.containersContainer.height() - this.nodes.linksContainer.height() + this.linksPaddingTop
			},
			triggerElement: this.nodes.containersContainer.get(0),
			offset: -this.options.headerHeight - this.linksPaddingTop,
			triggerHook: 0
		})
			.setPin(this.nodes.linksContainer.get(0))
			.addTo(this.controller);

		this.controller.scrollTo((newpos) => {
			$('html, body')
				.stop(true)
				.animate({scrollTop: newpos - this.options.headerHeight - this.containersItemPaddingTop});
		});

		this.nodes.links.each((index) => {
			this.nodes.links.eq(index).find('.link').on('click', (event) => {
				event.preventDefault();

				this.controller.scrollTo(this.nodes.containers.eq(index).get(0));
			});

			new ScrollMagic.Scene({
				duration: $$.windowHeight,
				triggerElement: this.nodes.containers.eq(index).get(0),
				triggerHook: 1
			})
				.setClassToggle(this.nodes.links.eq(index).get(0), "active")
				.addTo(this.controller);
		});
	}
};
